import { BrowserRouter, Routes, Route } from 'react-router-dom';
import DashboardPage from '../dashboard/DashboardPage';
import SideNav from '../component/SideNav';
import ClientPage from '../client/ClientPage';
import JobPage from '../job/JobPage';
import ItemPage from '../item/ItemPage';
import { useState } from 'react';
import { Menu } from 'lucide-react';

export default function Router() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <BrowserRouter>
      <div className="flex h-screen w-screen bg-slate-600 overflow-hidden">
        {/* Mobile overlay */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-20 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Sidebar */}
        <div
          className={`fixed lg:static z-30 h-full transition-transform duration-300 ${
            sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
          }`}
        >
          <SideNav onClose={() => setSidebarOpen(false)} />
        </div>

        {/* Content Area */}
        <div className="flex-1 overflow-auto flex flex-col min-w-0">
          {/* Mobile top bar */}
          <div className="lg:hidden bg-gray-900 px-4 py-3 flex items-center gap-3 shrink-0">
            <button
              onClick={() => setSidebarOpen(true)}
              className="text-white"
            >
              <Menu size={24} />
            </button>
            <span className="text-white font-bold">Job Maker - PHV</span>
          </div>

          <Routes>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/clients" element={<ClientPage />} />
            <Route path="/jobs" element={<JobPage />} />
            <Route path="/items" element={<ItemPage />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}
